import { render, staticRenderFns } from "./PanelSwiperLink.vue?vue&type=template&id=333c8ace"
import script from "./PanelSwiperLink.vue?vue&type=script&lang=js"
export * from "./PanelSwiperLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports